import React from "react"
import { Link, navigate } from "gatsby"
import {
    getUser, isLoggedIn, logout,
    // isSignedUp,
} from "../services/auth"
import { StaticImage } from "gatsby-plugin-image"

export default function NavBar() {
    let greetingMessage = ""
    if (isLoggedIn()) {
        greetingMessage = `Hello ${getUser().name}`
    } else {
        greetingMessage = "You are not logged in"
    }

    return (
        <div
            style={{
                display: "flex",
                flex: "1",
                justifyContent: "space-between",
                borderBottom: "1px solid #d1c1e0",
            }}
        >
            <Link to="/products">
                <StaticImage
                    src="../images/white-apple.png"
                    quality={95}
                    formats={["auto", "webp", "avif"]}
                    alt="Apple logo"
                    style={{
                        float: `left`,
                        marginBottom: `1.45rem`,
                        background: 'black',
                        width: `5px`
                    }}
                />
            </Link>
            <span>{greetingMessage}</span>
            <nav>
                {` `}
                <Link to="/products">iPhone</Link>
                {` `}
                <Link to="/macbook">MacBook Pro</Link>
                {` `}
                <Link to="/app/profile">Profile</Link>
                {` `}
                <Link to="/notify">Notify Me</Link>
                {` `}
                <Link to="/">Home</Link>
                {` `}
                {isLoggedIn() ? (
                    <a
                        href="/"
                        onClick={event => {
                            event.preventDefault()
                            logout(() => navigate(`/app/login`))
                        }}
                    >
                        Logout
                    </a>
                ) : null}
            </nav>
        </div>
    )
}
